/**
 * Erreurs liées aux types d'actions
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const ACTION_TYPE_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.ACTION_TYPE_SAVE_NOT_FOUND]: {
        messageKey: 'the-save-action-type-was-not-found',
        severity: 'error',
    },
};
